module.exports = __webpack_public_path__ + "static/img/speaker.412e7434.svg";